import { useQuery } from "@/compat/reactQuery";
import queryKeys from "../../../constants/queryKeys";
import riskAssessmentAcknowledgementService from "../../services/riskAssessmentAcknowledgementService";

// retry: false so an unrecognised email address fails once and shows Access Denied,
// rather than retrying a 404 three times first.
const useVerifiedRiskAssessmentAcknowledgement = ({ reference, emailAddress, readyToVerify }) =>
    useQuery(
        [queryKeys.verifiedRiskAssessmentAcknowledgement, reference, emailAddress],
        () => riskAssessmentAcknowledgementService.verify({ reference, emailAddress }),
        { enabled: !!reference && !!emailAddress && !!readyToVerify, retry: false }
    );

export default useVerifiedRiskAssessmentAcknowledgement;
